var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCardEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 6C0 3.23858 2.23858 1 5 1H9C9.55229 1 10 1.44772 10 2C10 2.55228 9.55229 3 9 3H5C3.34315 3 2 4.34315 2 6V15C2 16.6569 3.34315 18 5 18H14C15.6569 18 17 16.6569 17 15V11.5C17 10.9477 17.4477 10.5 18 10.5C18.5523 10.5 19 10.9477 19 11.5V15C19 17.7614 16.7614 20 14 20H5C2.23858 20 0 17.7614 0 15V6Z",
    fill: "#535F79"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.26003 14.0428L4.30434 15.6947L5.95652 10.7381L5.95702 10.7386L15.9336 0.697656C16.3804 0.250952 16.9862 0 17.618 0C18.2497 0 18.8556 0.250952 19.3023 0.697656C19.5235 0.918847 19.6989 1.18144 19.8187 1.47044C19.9384 1.75944 20 2.06919 20 2.38201C20 2.69482 19.9384 3.00457 19.8187 3.29357C19.6989 3.58257 19.5235 3.84517 19.3023 4.06636L9.26082 14.0436L9.26003 14.0428Z",
    fill: "#535F79"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardEdit);
export default __webpack_public_path__ + "static/media/card-edit.fa9b346637fba5e68ec8cbd6c89d91e5.svg";
export { ForwardRef as ReactComponent };